import React, { useEffect, useState } from "react";
import NumberFormat from "react-number-format";
import { FormattedMessage } from "react-intl";
import numeral from "numeral";

const Total = ({isReconciliationForm, isSave, requestBody, setRequestBody}) => {
  const [totalError, setTotalError] = useState(false);
    
  useEffect(() => {   
    if (!isSave) setTotalError(false); 
    else if (requestBody.status.confirmed) setTotalError(!requestBody.totalAmount);
  }, [isSave]);

  useEffect(() => {    
    if (!totalError) return;
    // if (!document.querySelector(".errorOccurs")) return;
    // faccio scrollare al primo elemento in errore
    document.querySelector(".errorOccurs")?.scrollIntoView();
  }, [totalError]);

  useEffect(() => {    
    setRequestBody({
      ...requestBody,
      totalAmount: requestBody.totalAmount
    });
  }, [requestBody.payment.type]);
  
  return (
    <div data-testid="container"       
      className={totalError ? "errorOccurs" : ""}>  
      <div style={{display:"flex", flexDirection: "column",        
        marginRight: "38px" }} className="numberFormat">
        <div className="labelDialogContent" style={{marginTop: 0}}>          
          {requestBody.frequencyType === "single" ? (
            <><FormattedMessage id="deadlines.pages.create.amountDeadlines" /> *</>
          ) : requestBody.scope === "rent" ||
          requestBody.scope === "financing" ||
          requestBody.scope === "recurring_fees" ? (
              <><FormattedMessage id="deadlines.pages.create.amountRata" /> *</>
            ) : (
              <><FormattedMessage id="deadlines.pages.create.amount" /> *</>
            )}
        </div> 
        <NumberFormat
          data-testid={"number-input"}
          allowLeadingZeros={true}
          value={(numeral(Math.abs(requestBody.totalAmount)).format("0,0.00"))}
          displayType={"input"}
          disabled={
            ((requestBody.scope === "fiscal_social_security" &&
              requestBody.status.confirmed === false) &&
            !isReconciliationForm)}
          placeholder={"0 €"}
          suffix={" €"}
          thousandSeparator={"."}
          decimalSeparator={","}
          /* onFocus={el => {
            onChange({
              ...requestBody,
              totalAmount:
                requestBody.totalAmount !== 0 ? requestBody.totalAmount : null
            });
          }}*/
          onValueChange={values => {
            const { /* formattedValue,*/ value } = values;                     
            setRequestBody({
              ...requestBody,
              // !! "item_collect" va verificato in requestBody.payment?.type e va messo -1 solo se non è incassata o da incassare
              totalAmount: value ? (requestBody.payment?.type === "item_collect" && requestBody.scope !== "fiscal_social_security" ? 1 : -1) * parseFloat(value) : 0 
            });
            setTotalError(false);
          }}
        />
      </div>
    </div>
  );
};

export default Total;